import React from 'react'
import {CircularProgress, Grid} from '@material-ui/core'
import {useTranslation} from 'react-i18next'

function BarcodeLoadingScreen(props) {
  const {t} = useTranslation()
  return (
    <Grid container>
      <Grid container item xs={12} justify="center">
        <CircularProgress size={props.size} />
      </Grid>
      <Grid container item xs={12} justify="center">
        {t('barcode.utils.loading-screen.loading')}
      </Grid>
    </Grid>
  )
}

export default BarcodeLoadingScreen
